/**
 * Enumeración de tipos de preguntas de encuestas y fases
 */
export enum QuestionType {
  TEXT = 'TEXT',
  CHOICE = 'CHOICE',
  RATING = 'RATING',
  MESSAGE = 'MESSAGE',
  FILE = 'FILE',
  AUTOCOMPLETE = 'AUTOCOMPLETADO'
}

export const QuestionTypeTranslations: Record<QuestionType, string> = {
  [QuestionType.TEXT]: 'survey.question_type.text',
  [QuestionType.CHOICE]: 'survey.question_type.choice',
  [QuestionType.RATING]: 'survey.question_type.rating',
  [QuestionType.MESSAGE]: 'survey.question_type.message',
  [QuestionType.FILE]: 'survey.question_type.file',
  [QuestionType.AUTOCOMPLETE]: 'survey.question_type.autocomplete',
};

export enum SurveyPhase {
  DEPARTURE = 'DEPARTURE',
  ARRIVAL = 'ARRIVAL'
}

export const SurveyPhaseTranslations: Record<SurveyPhase, string> = {
  [SurveyPhase.DEPARTURE]: 'transports.survey.pickup_survey',
  [SurveyPhase.ARRIVAL]: 'transports.survey.delivery_survey',
};
